(() => {
  'use strict';

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-rlc-organic-article]').forEach((article) => {
      if (article.dataset.rlcOrganicReady) return;
      article.dataset.rlcOrganicReady = 'true';
      const rail = article.querySelector('[data-rlc-organic-toc]');
      if (!rail) return;
      const links = Array.from(rail.querySelectorAll('a[href^="#"]'));
      const entries = links.map((link) => {
        let id;
        try { id = decodeURIComponent(link.hash.slice(1)); } catch { return null; }
        const heading = document.getElementById(id);
        if (!heading || !article.contains(heading)) return null;
        link.addEventListener('click', () => {
          heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        });
        return { link, heading };
      }).filter(Boolean);
      if (!('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((changes) => {
        const visible = changes.filter((change) => change.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (!visible.length) return;
        entries.forEach(({ link, heading }) => {
          if (heading === visible[0].target) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }, { rootMargin: '-5% 0px -65% 0px', threshold: 0 });
      entries.forEach(({ heading }) => observer.observe(heading));
    });
  };

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  initialize();
})();
